module.exports = __webpack_public_path__ + "static/6-1a0ea682c870c642eb9bdeba35aa9ab5.png";